<template>
  <div class="donation-form">
    <h1>{{ $t("donationForm.title") }}</h1>
    <div v-if="this.request.finish == false">
      <ul v-if="this.request.answers.length">
        <li>{{ $t("donationForm.listItem1") }}</li>
        <li>{{ $t("donationForm.listItem2") }} (PDF, JPG of PNG)</li>
        <li>{{ $t("donationForm.listItem3") }}</li>
      </ul>
      <div v-if="error" class="errorMsg">
        <strong>{{ $t("donationForm.errorTitle") }}</strong>
        <p>{{ $t("donationForm.errorMessage") }}</p>
      </div>
      <form
        v-if="this.request.answers.length"
        enctype="multipart/form-data"
        @submit.prevent="handleSubmit"
      >
        <f-input
          class="small"
          :value="input.name"
          @input="handleInput"
          :title="$t('donationForm.field1')"
          :placeholder="$t('donationForm.field1placeholder')"
          :data="'name'"
          :type="'text'"
          :required="true"
        />
        <f-input
          class="small right"
          :value="input.contact_name"
          @input="handleInput"
          :title="$t('donationForm.field2')"
          :placeholder="$t('donationForm.field2placeholder')"
          :data="'contact_name'"
          :type="'text'"
          :required="true"
        />
        <f-input
          :value="input.address"
          @input="handleInput"
          :title="$t('donationForm.field3')"
          :placeholder="$t('donationForm.field3placeholder')"
          :data="'address'"
          :type="'textarea'"
          :required="true"
        />
        <f-input
          v-if="input.country"
          @input="handleInput"
          :title="$t('donationForm.field4')"
          :placeholder="$t('donationForm.field4placeholder')"
          :data="'country'"
          :value="input.country"
          :type="'text'"
          :required="true"
        />
        <f-input
          class="small"
          :value="input.phone"
          @input="handleInput"
          :title="$t('donationForm.field5')"
          :placeholder="$t('donationForm.field5placeholder')"
          :data="'phone'"
          :type="'text'"
          :required="true"
        />
        <f-input
          class="small right"
          :value="input.email"
          @input="handleInput"
          :title="$t('donationForm.field6')"
          :placeholder="$t('donationForm.field6placeholder')"
          :data="'email'"
          :type="'text'"
          :required="true"
        />
        <f-input
          @input="handleInput"
          :title="$t('donationForm.field7')"
          :placeholder="$t('donationForm.field7placeholder')"
          :value="input.iban"
          :data="'iban'"
          :type="'text'"
          :required="true"
        />

        <!-- SWIFT & BIC!! (8 & 9) -->
        <f-input
          v-if="input.country"
          class="small"
          :value="input.bic"
          @input="handleInput"
          :title="$t('donationForm.field8')"
          :placeholder="$t('donationForm.field8placeholder')"
          :data="'bic'"
          :type="'text'"
        />
        <f-input
          v-if="input.country"
          class="small right"
          :value="input.swift"
          @input="handleInput"
          :title="$t('donationForm.field9')"
          :placeholder="$t('donationForm.field9placeholder')"
          :data="'swift'"
          :type="'text'"
        />

        <f-input
          v-if="input.anbi !== '-'"
          @input="handleInput"
          :title="$t('donationForm.field10')"
          :placeholder="$t('donationForm.field10placeholder')"
          :data="'anbi'"
          :value="input.anbi"
          :type="'text'"
          :required="true"
        />
        <f-input
          class="small"
          @input="handleInput"
          :value="input.total_costs"
          :title="$t('donationForm.field11')"
          :placeholder="$t('donationForm.field11placeholder')"
          :data="'total_costs'"
          :type="'text'"
          :required="true"
        />
        <f-input
          class="small right"
          @input="handleInput"
          :value="input.total_request"
          :title="$t('donationForm.field12')"
          :placeholder="$t('donationForm.field12placeholder')"
          :data="'total_request'"
          :type="'text'"
          :required="true"
        />
        <f-input
          @input="handleInput"
          :value="input.description"
          :title="$t('donationForm.field13')"
          :placeholder="$t('donationForm.field13placeholder')"
          :data="'description'"
          :type="'textarea'"
          :required="true"
        />
        <f-input
          @input="handleInput"
          :title="$t('donationForm.field14')"
          :placeholder="$t('donationForm.field14placeholder')"
          :value="input.garant"
          :data="'garant'"
          :type="'textarea'"
          :required="true"
        />

        <div class="test-group">
          <p class="button-label">
            {{ $t("donationForm.field15") }}
          </p>

          <div class="button-group">
            <f-button
              :class="input.hasRequestedBefore ? 'active' : ''"
              @click.prevent="input.hasRequestedBefore = true"
              :value="$t('buttons.yes')"
              :key="$t('buttons.yes')"
              >{{ $t("buttons.yes") }}</f-button
            >
            <f-button
              :class="!input.hasRequestedBefore ? 'active' : ''"
              @click.prevent="input.hasRequestedBefore = false"
              :value="$t('buttons.no')"
              :key="$t('buttons.no')"
              >{{ $t("buttons.no") }}</f-button
            >
          </div>
        </div>

        <p class="bijlagen">
          <strong
            >{{ $t("donationForm.content1") }} ({{
              $t("donationForm.only")
            }}
            PDF, JPG of PNG)</strong
          >
        </p>
        <div class="file-uploads">
          <input
            @change="setFile($event, 'fileOne')"
            type="file"
            id="upload-1"
            accept="application/pdf, image/jpeg, image/png, application/vnd.ms-excel"
          />
          <input
            @change="setFile($event, 'fileTwo')"
            type="file"
            id="upload-2"
            accept="application/pdf, image/jpeg, image/png, application/vnd.ms-excel"
          />
          <input
            @change="setFile($event, 'fileThree')"
            type="file"
            id="upload-3"
            accept="application/pdf, image/jpeg, image/png, application/vnd.ms-excel"
          />
          <input
            type="file"
            id="upload-3"
            accept="application/pdf, image/jpeg, image/png, application/vnd.ms-excel"
          />
          <div @click="upload('upload-1')" class="upload">
            <img src="@/assets/img/plus.png" />
          </div>
          <div @click="upload('upload-2')" class="upload">
            <img src="@/assets/img/plus.png" />
          </div>
          <div @click="upload('upload-3')" class="upload">
            <img src="@/assets/img/plus.png" />
          </div>
        </div>
        <f-button @click="send">{{ $t("donationForm.sendButton") }}</f-button>
      </form>
      <div v-if="!request.answers.length" class="noAnswers">
        <p>{{ $t("donationForm.noanswers") }}</p>
        <br />
        <p>
          <strong
            >{{ $t("donationForm.goto") }} <a href="/">homepage</a></strong
          >
        </p>
      </div>
    </div>
    <div v-if="this.request.finish == true" class="noAnswers">
      <p>
        <strong>{{ $t("donationForm.thanks") }}</strong>
      </p>
      <br />
      <p>{{ $t("donationForm.thankssub") }}</p>
      <br />
      <p>{{ $t("donationForm.thankssubhint") }}</p>
    </div>
  </div>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
import MailService from "@/services/MailServices";
import { parseTemplate } from "@/assets/scripts/mail";

export default {
  name: "DonationForm",
  components: {},
  props: [],

  /* ------------------------------ */
  /* DATA */
  data() {
    return {
      input: {
        name: "",
        contact_name: "",
        address: "",
        country: "",
        phone: "",
        email: "",
        iban: "",
        anbi: "",
        total_costs: "",
        total_request: "",
        description: "",
        category: "",
        status: "",
        garant: "",
        bic: "",
        swift: "",
        hasRequestedBefore: false,
        fileOne: null,
        fileTwo: null,
        fileThree: null,
      },
      error: false,
      request: {
        answers: this.$store.state.GateKeeperAnswers,
        finish: false,
        error: false,
      },
    };
  },

  /* ------------------------------ */
  /* LIFECYCLE HOOKS */
  /* note: do not use arrow functions here */
  mounted: function () {
    var self = this;
    if (this.request.answers) {
      this.request.answers.forEach(function (answer) {
        if (answer.id === "land") {
          self.input.country = answer.response;
        }
        if (answer.id === "anbi") {
          if (answer.response) {
            self.input.anbi = answer.response;
          } else {
            self.input.anbi = "-";
          }
        }
        if (answer.id === "garantie") {
          if (answer.response) {
            self.input.garant = answer.response;
          } else {
            self.input.garant = "-";
          }
        }
        if (answer.id === "categorie") {
          if (answer.response) {
            self.input.category = answer.response;
          } else {
            self.input.category = "Anders";
          }
        }
      });
    }
    /* Set garant default */
    if (this.input.garant.length === 0) {
      this.input.garant = "";
    }
  },
  updated: function () {
    var inputElements = document.getElementsByTagName("input");
    for (var i = 0; i < inputElements.length; i++) {
      var input = inputElements[i];
      if (input.getAttribute("type") === "text") {
        if (input.value.length > 0) {
          input.classList.add("valid");
        } else {
          input.classList.remove("valid");
        }
      }
    }
  },

  /* ------------------------------ */
  /* METHODS ETC */
  methods: {
    handleInput: function (type, value) {
      /* Set the value by it's key */
      this.input[type] = value;
    },
    handleSubmit: function (event) {
      event.preventDefault();
    },
    upload: function (selector) {
      /* Simulate the click event */
      document.getElementById(selector).click();
    },
    setRequestedBefore: function (value) {
      //   console.log(event);
      //   if ($event) $event.preventDefault();
      this.input.hasRequestedBefore = value;
    },
    setFile(e, id) {
      /* Get the files from the event property */
      const files = e.target.files;
      /* Check if there are files */
      if (files && files.length) {
        /* Set the first, and only file as input on data object */
        this.input[id] = files[0];
      }
      let targetId = parseInt(e.target.id.split("-")[1], 10) - 1;
      /* Change the image */
      var block = document.getElementsByClassName("upload")[targetId];
      var imgBlock = block.getElementsByTagName("img")[0];
      /* Set the image */
      imgBlock.src = require("../assets/img/check.png");
    },
    async send(event) {
      /* Prevent the default behaviour */
      event.preventDefault();
      /* Invalid fields state counter */
      let invalidCount = 0;
      /* Get all required fields */
      const requiredFields = document.querySelectorAll("[required]");
      /* Loop over the required fields */
      requiredFields.forEach(function (field) {
        /* Check if we got a lenght */
        if (field.value.length === 0) {
          /* Add to invalid */
          invalidCount += 1;
          /* Add the invalid class */
          field.classList.add("invalid");
        } else {
          /* Remove invalid if set */
          field.classList.remove("invalid");
        }
      });
      if (
        this.input.fileOne === null &&
        this.input.fileTwo === null &&
        this.input.fileThree === null
      ) {
        invalidCount += 1;
      }
      if (invalidCount > 0) {
        /* We got an error */
        this.error = true;
        /* Scroll back to the top */
        window.scrollTo(0, 0);
      } else {
        /* First we create a new form data object */
        const formDataObject = new FormData();
        /* Loop over the input */
        for (let item in this.input) {
          /* Check for length */
          if (typeof this.input[item] === "string" && this.input[item].length) {
            /* Append the form data */
            formDataObject.append(item, this.input[item]);
          }
        }
        if (this.input.fileOne) {
          formDataObject.append("fileOne", this.input.fileOne);
        }
        if (this.input.fileTwo) {
          formDataObject.append("fileTwo", this.input.fileTwo);
        }
        if (this.input.fileThree) {
          formDataObject.append("fileThree", this.input.fileThree);
        }
				if(this.input.hasRequestedBefore) {
					formDataObject.append('hasRequestedBefore', this.input.hasRequestedBefore);
				}
        /* Get the response */
        const response = await MailService.send(formDataObject);
        /* TODO: CHeck for errors */
        this.request.finish = true;
      }
    },
  },
  computed: {},
  watch: {},
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>
.donation-form {
  .noAnswers {
    padding: 20px;
    a {
      color: blue;
      text-decoration: underline;
    }
  }

  @include max-medium {
    margin-bottom: $margin-bottom-mobile;
  }

  @include min-large {
    margin-bottom: $margin-bottom-desktop;
  }

  padding: 0 1em;

  @include maxWidthCenter(800px);

  .bijlagen {
    margin-top: 1em;
    text-align: center;
  }

  .file-uploads {
    @include flex(space-around, stretch);
    @include maxWidthCenter(400px);
    margin-top: 1em;

    .upload {
      position: relative;
      padding: 2.5em;
      background: #f6f6f6;
      cursor: pointer;

      img {
        max-width: 70%;
        @include pos-absolute-center;
      }
    }
  }

  input[type="file"] {
    font-size: 100px;
    position: absolute;
    left: -999px;
    top: -999px;
    opacity: 0;
  }

  button.filled {
    width: 100%;
    margin: 2.5em 0;

    @include min-large {
      display: block;
      @include maxWidthCenter(270px);
    }
  }
}

.button-label {
  color: #81c1c0;
  font-weight: 600;
  font-size: 0.9em;
}

.button-group {
  display: flex;
  button {
    margin: 10px 15px 10px 0 !important;
  }
}

.errorMsg {
  margin: 2em 0 0.5em;
  color: red;
}

form {
  .form-group {
    display: inline-block;
    width: 100%;
  }
  @include min-large {
    .small {
      display: inline-block;
      width: 48%;
      margin-top: calc(1.5em / 2);
      margin-bottom: calc(1.5em / 2);
      &.right {
        margin-left: 4%;
      }
    }
  }
}
</style>
